import React from "react";
import { useTranslation } from "react-i18next";
import EcoProButton from "../../../../../shared/button/button";

const EasyPayPlanGetStartedButton = (props) => {
    const { t } = useTranslation(["translation"]);
    const {
        isTermsAndconditionsAgreed,
        handleGetStartedBrotherPlus
    } = props;
    return (
        <div className="brother-plus-banner get-started-container align-to-center">
            <EcoProButton cname="default" disabled={(isTermsAndconditionsAgreed) ? false : true } onBtnClick={handleGetStartedBrotherPlus}>
                {t('BROTHER_PLUS.EASY_PAY_BANNER.GETSTARTED_TXT')}
            </EcoProButton>
        </div>
    )
}

export default EasyPayPlanGetStartedButton;